export const renewalEsTranslation = {
  renewal: {
    steps: {
      choose: "Elegir",
      term: "Plazo del contrato",
      next: "Siguientes pasos",
      moveOut: "Aviso de desocupación",
      of: "Paso {{current}} de {{total}}",
      back: "Atrás",
      continue: "Continuar",
    },
    choice: {
      title: "Renovar o mudarse",
      subtitle: "¿Va a renovar o a mudarse?",
      renew: "Renovar el contrato",
      renewDescription: "Quédese en su hogar y elija un nuevo plazo.",
      moveOut: "Enviar aviso de desocupación",
      moveOutDescription:
        "Indíquenos su fecha de mudanza y los siguientes pasos.",
    },
    stub: {
      renewTitle: "Renovar el contrato",
      renewBody:
        "La selección de plazo y la firma llegarán pronto. Por ahora, vuelva al inicio o use la solicitud de renovación de su propiedad si ya tiene instrucciones.",
      moveOutTitle: "Aviso de desocupación",
      moveOutBody:
        "El aviso de desocupación en autoservicio llegará pronto. Comuníquese con el equipo de la propiedad si necesita dar aviso hoy.",
      backHome: "Volver al inicio",
    },
    terms: {
      title: "Elija un plazo de contrato",
      subtitle: "Revise los plazos y tarifas de renovación aprobados.",
      rentOnlyNote:
        "Los montos mostrados son solo la renta mensual. Otros cargos recurrentes no se incluyen en esta comparación.",
      months_one: "{{count}} mes",
      months_other: "{{count}} meses",
      months: "{{count}} meses",
      termLabel_one: "Contrato de {{count}} mes",
      termLabel_other: "Contrato de {{count}} meses",
      termLabel: "Contrato de {{count}} meses",
      colTerm: "Seleccionar plazo",
      colRent: "Renta",
      colDates: "Fechas del contrato",
      perMonth: "/ mes",
      preferred: "Preferido",
      continue: "Continuar",
      empty:
        "Aún no hay plazos de renovación disponibles para su contrato. Comuníquese con el equipo de la propiedad.",
      nextTitle: "Plazo seleccionado",
      nextBody:
        "Su plazo quedó guardado. La actualización de datos del hogar y la firma de la renovación vienen a continuación.",
    },
    banner: {
      selfServiceLink: "Comenzar",
    },
  },
};
